export const PUSH_ALERT_MESSAGE = "PUSH_ALERT_MESSAGE";

export const SHFIT_ALERT_MESSAGE = "SHFIT_ALERT_MESSAGE";

export const DELETE_ALERT_MESSAGE = "DELETE_ALERT_MESSAGE";
